import { red } from "@material-ui/core/colors";
import React from "react";
import { ValidatorComponent } from "react-material-ui-form-validator";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./style.css";

const red300 = red["500"];

const style = {
  left: 0,
  fontSize: "12px",
  color: red300,
  position: "absolute",
  marginTop: "5px",
  marginBottom: "5px",
};

class InputTextareaEditor extends ValidatorComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      helperText,
      name,
      value,
      modules,
      formats,
      placeholder,
      onChange,
      showToolBar,
      disabled,
      ...rest
    } = this.props;
    const { isValid } = this.state;

    return (
      <div
        className={
          showToolBar
            ? isValid
              ? "input-textarea-editor"
              : "input-textarea-editor has-error"
            : isValid
            ? "input-textarea-editor hidden-toolbar"
            : "input-textarea-editor hidden-toolbar has-error"
        }
        style={{
          position: "relative",
          marginBottom: 40,
          marginTop: 25,
        }}
      >
        <ReactQuill
          {...rest}
          name={name}
          value={value}
          modules={modules}
          formats={formats}
          // rows="10"
          readOnly={disabled ? true : false}
          style={{ height: "5rem", marginBottom: "5rem" }}
          onChange={(content, delta, source, editor) => {
            if (editor.getHTML() === "<p><br></p>") {
              onChange({ name: `${name}`, value: "" });
            } else {
              onChange({ name: `${name}`, value: `${content}` });
            }
          }}
          placeholder={placeholder}
          error={!isValid}
          ref={(r) => {
            this.input = r;
          }}
          helperText={!isValid ? this.getErrorMessage() : helperText}
        ></ReactQuill>
        {!isValid && this.errorText()}

        {isValid && helperText}
      </div>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    } else {
      return <div style={style}>{this.getErrorMessage()}</div>;
    }
  }
}

export default InputTextareaEditor;
